import moment from "moment";

export type Side = "main" | "compare";

export type CellType = "prev" | "current" | "next";

// panel start
export class PanelDate {
  year = 0;
  month = 0;
  daysInMonth = 0;
  firstDay = 0;
  trailing = 0;

  constructor(fields?: Partial<PanelDate>) {
    Object.assign(this, fields);
  }
}

export class Panel {
  main = new PanelDate();
  compare = new PanelDate();

  constructor(fields?: Partial<Panel>) {
    Object.assign(this, fields);
  }
}

export class SelectingStart {
  selectingStart = false;

  constructor(fields?: Partial<SelectingStart>) {
    Object.assign(this, fields);
  }
}

export class PanelSelectingStart {
  main = new SelectingStart();
  compare = new SelectingStart();

  constructor(fields?: Partial<PanelSelectingStart>) {
    Object.assign(this, fields);
  }
}
// panel end

// range start
export class Range {
  start: Date | null = null;
  end: Date | null = null;

  constructor(fields?: Partial<Range>) {
    Object.assign(this, fields);
  }
}

export class DateRange {
  main = new Range();
  compare = new Range();

  constructor(fields?: Partial<DateRange>) {
    Object.assign(this, fields);
  }
}
// range end

// cell start
export class Cell {
  day = 0;
  type: CellType = "current";
  year = 0;
  month = 0;

  constructor(fields?: Partial<Cell>) {
    Object.assign(this, fields);
  }
}
// cell end

// behaviour start
export class HoverDate {
  main: moment.Moment | null = null;
  compare: moment.Moment | null = null;

  constructor(fields?: Partial<HoverDate>) {
    Object.assign(this, fields);
  }
}
// behaviour end
